"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DatePickerHorizontalStack = void 0;
var _HorizontalStack = _interopRequireDefault(require("../../../HorizontalStack/index.js"));
var _react = _interopRequireDefault(require("react"));
var _DatePickerCenterContainer = _interopRequireDefault(require("./DatePickerCenterContainer.js"));
var _jsxRuntime = require("react/jsx-runtime");
const DatePickerHorizontalStack = props => {
  const {
    sDate,
    eDate,
    setStartDate,
    setEndDate,
    daysColor,
    disabledDaysColor,
    weekdayNames,
    days,
    index,
    setSelectedDate,
    daysPerWeek,
    currentYearMonth,
    maxDate,
    minDate,
    selDate,
    selDates,
    disabledDates,
    mode,
    selectedDate,
    onDateChange,
    onChangeDatesHande,
    onChangeStartEndDateHandle,
    borderRadius,
    calenderBoxShadow,
    calenderBorderWidth,
    calenderBorderStyle,
    calenderBorderColor,
    dateWeekHeight,
    dateWeekWidth,
    dateWeekMargin,
    dateBgColor,
    hoverDateBgColor,
    dateBorderRadius,
    dateBorderWidth,
    dateBorderStyle,
    dateBorderColor,
    dateBoxShadow,
    dateFontFamily,
    dateFontStyle,
    dateFontWeight,
    dateFontSize,
    dateTransformation,
    dateDecoration,
    hoverDateTextColor,
    dateLineHeight,
    disabledDateBgColor,
    disabledDateBorderRadius,
    disabledDateBorderWidth,
    disabledDateBorderStyle,
    disabledDateBorderColor,
    disabledDateBoxShadow,
    disabledDateFontFamily,
    disabledDateFontStyle,
    disabledDateFontWeight,
    disabledDateFontSize,
    disabledDateTransformation,
    disabledDateDecoration,
    disabledDateTextColor
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_HorizontalStack.default, {
    justifyContent: "space-between",
    children: weekdayNames && weekdayNames.map((_cell, cellIndex) => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePickerCenterContainer.default, {
        sDate: sDate,
        eDate: eDate,
        setStartDate: setStartDate,
        setEndDate: setEndDate,
        daysColor: daysColor,
        disabledDaysColor: disabledDaysColor,
        days: days,
        index: index,
        daysPerWeek: daysPerWeek,
        currentYearMonth: currentYearMonth,
        maxDate: maxDate,
        minDate: minDate,
        today: minDate,
        selDate: selDate,
        selDates: selDates,
        cellIndex: cellIndex,
        disabledDates: disabledDates,
        mode: mode,
        setSelectedDate: setSelectedDate,
        selectedDate: selectedDate,
        onDateChange: onDateChange,
        onChangeDatesHande: onChangeDatesHande,
        onChangeStartEndDateHandle: onChangeStartEndDateHandle,
        borderRadius: borderRadius,
        calenderBoxShadow: calenderBoxShadow,
        calenderBorderWidth: calenderBorderWidth,
        calenderBorderStyle: calenderBorderStyle,
        calenderBorderColor: calenderBorderColor,
        dateWeekHeight: dateWeekHeight,
        dateWeekWidth: dateWeekWidth,
        dateWeekMargin: dateWeekMargin,
        dateBgColor: dateBgColor,
        hoverDateBgColor: hoverDateBgColor,
        dateBorderRadius: dateBorderRadius,
        dateBorderWidth: dateBorderWidth,
        dateBorderStyle: dateBorderStyle,
        dateBorderColor: dateBorderColor,
        dateBoxShadow: dateBoxShadow,
        dateFontFamily: dateFontFamily,
        dateFontStyle: dateFontStyle,
        dateFontWeight: dateFontWeight,
        dateFontSize: dateFontSize,
        dateTransformation: dateTransformation,
        dateDecoration: dateDecoration,
        hoverDateTextColor: hoverDateTextColor,
        dateLineHeight: dateLineHeight,
        disabledDateBgColor: disabledDateBgColor,
        disabledDateBorderRadius: disabledDateBorderRadius,
        disabledDateBorderWidth: disabledDateBorderWidth,
        disabledDateBorderStyle: disabledDateBorderStyle,
        disabledDateBorderColor: disabledDateBorderColor,
        disabledDateBoxShadow: disabledDateBoxShadow,
        disabledDateFontFamily: disabledDateFontFamily,
        disabledDateFontStyle: disabledDateFontStyle,
        disabledDateFontWeight: disabledDateFontWeight,
        disabledDateFontSize: disabledDateFontSize,
        disabledDateTransformation: disabledDateTransformation,
        disabledDateDecoration: disabledDateDecoration
      }, Math.random());
    })
  });
};
exports.DatePickerHorizontalStack = DatePickerHorizontalStack;
var _default = exports.default = DatePickerHorizontalStack;